import gsap from 'gsap'

import {
  getScrollTriggerOptions,
  linesRevealAnimation,
  paragraphRevealAnimation,
  SharedAnimation
} from './shared'
import { Animation } from '@/types'

export const imageTextRevealAnimation = ({
  node,
  mobile,
  context,
  reverse
}: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const title = selector('[data-motion-title]')[0]
  const paragraph = selector('[data-motion-paragraph]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse)
  })

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, '<')
  }

  let paragraphAnimation: SharedAnimation
  if (paragraph) {
    paragraphAnimation = paragraphRevealAnimation(paragraph, reverse)
    timeline.add(paragraphAnimation.timeline, '<+0.2')
  }

  return () => {
    timeline.kill()

    titleAnimation?.revert()
    paragraphAnimation?.revert()
  }
}
